import React, { useState, useEffect } from "react";
import styles from "../../styles/components/botDetailUser.module.scss";
import Icons from "../../public/assets/svg";
import ReactPlayer from "react-player";
import Botcard from "../../components/dynamicBotCard";
import GetBotModal from "../../components/getBotModal";
import { editCurrentBot } from "../../redux/storeBot/actions";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import axios from "axios";
import Loader from "../Loader";
import endpoints from "../../utility/endpoints";
import SuccessModal from "../../pages/successModal";
import { saveCurrentBot } from "../../redux/storeBot/actions";
import Dropdown from "../listWithoutcheck";
import _ from "lodash";
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// // import { faQuoteLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

import {AiOutlineCopy,AiOutlineCheck} from "react-icons/ai"
import ClipboardJS from 'clipboard';
import AssociateBots from "./AssociateBots";
import { useSas } from "../../lib/store/useSasStore";
import review_modal_img from "../botApproval/assets/bot_approval_img.jpg";
import Image from "next/image";

const options = {
  cMapUrl: "cmaps/",
  cMapPacked: true,
};

function index(props) {
  //console.log(props, "props at bot detail ");
  //const routes = props.globalData.menu_component.menu_list;
  const [myBot, setMyBot] = React.useState(null);
  const dispatch = useDispatch();
  const router = useRouter(); //"businessUserRegionWise", // //"businessUserRegionWise",
  const {sasToken}=useSas();
  const [associateBotIds, setAssociateBotIds] = useState([]);
  const [reviewModal, setReviewModal] = useState(false);

  const convertToDDMMYYYY = (date) => {
  
    if (date && date != "NA") {
      let year = date.slice(0, 4);
      let month = date.slice(5, 7);
      let day = date.slice(8, 10);

      let newDate = day + "-" + month + "-" + year;
      return newDate;
    }
    else {
      return "--";
    }
  };
   /**
* 	
* Bot ID ---done
Lead Platform --done
Area -- done 
Sub Area - done 
Process Name --done
Process Description --done
Cluster -- Done
MCO ---  Done
Country --- Done
Technology--DOne
Primary Application --DOne
Status --done
Process Criticality --
KFA --Done
TCode --Done
Requester email ID  -done 
Business Owner Email ID --done
Created By -done
Engagement Lead -done
*/ //
  // restricted user
  /**
   * "businessUserRegionWise",
    "businessUserRegionWise",
   */ const [restrictedUserBotView, setRestrictedUserBotView] = useState([
    "businessOwner",
    "endUser",
  ]);

  const [restrictedViewDetails, setRestrictedViewDetails] = useState(true);
  const restrictedUserDocumentView = [
    "businessUserRegionWise",
    "endUser",
    "businessOwner",
  ];

  const restrictedDocumentTypes = ["SOP", "PDD"];

  const allDocumentTypes = [
    "sopDocument",
    "pddDocument",
    "pddApprovalDocument",
    "sddDocument",
    "qsgDocument",
    "odiDocument",
    "brdDocument",
    "costApprovalDocument",
    "explicitLandscapeApplicationOwnerApprovalDocument",
    "explicitGPMApprovalSupplyChainFinanceDocument",
    "explicitGFCFApprovalDocument",
    "devQualityCredentialsAvailableDocument",
    "infosecApprovalDocument",
    "dAReviewSignOffDocument",
    "testDataAvailableForDevelopmentDocument",
    "requestRaisedForProductionCredentialsDocument",
    "internalTestingCompletedDocument",
    "peerReviewSignOffDocument",
    "daReviewSecondSignOffDocument",
    "bpReleaseSignOffFromDaDocument",
    "uatScriptsWithResultsDocument",
    "uatSignOffDocument",
    "releaseManagerSignOffDocument",
    "gateFormDocument",
    "peerReviewchecklistDocument",
    "qaSignOffDocument",
    "walkthroughVideo",
    "ktVideo",
  ];

  let documentAr = [
    { title: "SOP", value: "sopDocument", type: [".pdf", ".doc", ".docx"] },
    { title: "PDD", value: "pddDocument", type: [".pdf", ".doc", ".docx"] },
    {
      title: "PDD Approval",
      value: "pddApprovalDocument",
      type: [".msg", ".png"],
    },
    { title: "SDD", value: "sddDocument", type: [".pdf", ".doc", ".docx"] },
    { title: "QSG", value: "qsgDocument", type: [".doc", ".docx"] },
    { title: "ODI", value: "odiDocument", type: [".xlxs", ".xls"] },
    { title: "BRD", value: "brdDocument", type: [".xlxs", ".xls"] },
    {
      title: "Cost Apporval",
      value: "costApprovalDocument",
      type: [".msg", ".png"],
    },
    {
      title: "Landscape Approval",
      value: "explicitLandscapeApplicationOwnerApprovalDocument",
      type: ".msg",
    },
    {
      title: "GPM Approval",
      value: "explicitGPMApprovalSupplyChainFinanceDocument",
      type: [".msg", ".png"],
    },
    {
      title: "GFCF Approval",
      value: "explicitGFCFApprovalDocument",
      type: [".msg", ".png"],
    },
    {
      title: "Dev Quality Crendentails Available",
      value: "devQualityCredentialsAvailableDocument",
      type: ".msg",
    },
    {
      title: "Infosec Approval",
      value: "infosecApprovalDocument",
      type: ".msg",
    },
    {
      title: "DA Review Sign Off",
      value: "dAReviewSignOffDocument",
      type: ".msg",
    },
    {
      title: "Test Data Development",
      value: "testDataAvailableForDevelopmentDocument",
      type: [".xlxs", ".xls"],
    },
    {
      title: "Request Raised Product Credentials",
      value: "requestRaisedForProductionCredentialsDocument",
      type: ".msg",
    },
    {
      title: "Internal Testing Completed",
      value: "internalTestingCompletedDocument",
      type: ".msg",
    },
    {
      title: "Peer Review Sign Off",
      value: "peerReviewSignOffDocument",
      type: ".msg",
    },
    {
      title: "DA Review Second Sign Off",
      value: "daReviewSecondSignOffDocument",
      type: ".msg",
    },
    {
      title: "BP Release Sign Off",
      value: "bpReleaseSignOffFromDaDocument",
      type: ".msg",
    },
    {
      title: "UAT Scripts With Results",
      value: "uatScriptsWithResultsDocument",
      type: [".xlxs", ".xls"],
    },

    {
      title: "Release Manager Sign Off",
      value: "releaseManagerSignOffDocument",
      type: ".msg",
    },
    { title: "Gate Form", value: "gateFormDocument", type: [".xlxs", ".xls"] },
    {
      title: "Peer Review Checklist",
      value: "peerReviewchecklistDocument",
      type: [".xlxs", ".xls"],
    },
    { title: "QA Sign Off", value: "qaSignOffDocument", type: ".msg" },
    {
      title: "Walk Through Video",
      value: "walkthroughVideo",
      type: [".mov", ".mp4", ".avi"],
    },
    { title: "KT Video", value: "ktVideo", type: [".mov", ".mp4", ".avi"] },
  ];

  // React.useEffect(() => {
  //   for (let i in )
  // }, [])

  const [noRestrictedUser, setnoRestrictedUser] = useState([
    "admin",
    "gfcf",
    "firstGfcf",
    "firstLevelGPMApprover",
    "GPMapprover",
    "gCad",
    "qrManager",
    "internalUser",
    "supportStatus",
  ]);

  const [documentTypes, setDocumentTypes] = useState([]);

  React.useEffect(() => {
    //console.log("mybotUse Effect");
    //console.log("auth --mybot", auth);
    if (myBot != null) {
      //console.log("Restricted User", restrictedUser);
      if (myBot.businessOwnerEmailID == auth.email) {
        setRestrictedViewDetails(false);
      } else if (restrictedUser.includes(auth.userType)) {
        setRestrictedViewDetails(true);
      } else {
        setRestrictedViewDetails(false);
      }
      //console.log("my bot bot detail end user ---", myBot);
      let documentsToSet = [];
      for (let i in documentAr) {
        {/*console.log(
          "My bot document value  ---",
          myBot[documentAr[i]["value"]]
        );*/}
        if (
          myBot[documentAr[i]["value"]] !== undefined &&
          myBot[documentAr[i]["value"]] !== null &&
          myBot[documentAr[i]["value"]] !== "" &&
          myBot[documentAr[i]["value"]] !== "can be empty"
        ) {
          //console.log("what Input doc-----", myBot[documentAr[i]["value"]]);
          documentsToSet.push(documentAr[i].title);
        }
      }
      // if (myBot.botDemoVideo != undefined && myBot.botDemoVideo !== "" && myBot.botDemoVideo != undefined) {
      //   documentsToSet.push("Bot Demo Vedio");
      // }
      //console.log(documentsToSet, "DOCumentstoset");
      if (restrictedUserDocumentView.includes(auth.userType)) {
        if (auth.userType == "businessOwner") {
          //console.log(myBot.businessOwnerEmailID, "DOCumentstoset");
          //console.log(auth.email, "DOCumentstoset");
          if (myBot.businessOwnerEmailID == auth.email) {
            
            //console.log(documentsToSet, "DOCumentstoset");
            setDocumentTypes([...documentsToSet]);
          } else {
            let restrictedNewDocumented = []
            if (documentsToSet.includes("SOP")) {
              restrictedNewDocumented.push("SOP")
            }
            if (documentsToSet.includes("PDD")) {
             restrictedNewDocumented.push("PDD")
           }
            
           setDocumentTypes(restrictedNewDocumented);
          }
        }
       else {
         let restrictedNewDocumented = []
         if (documentsToSet.includes("SOP")) {
           restrictedNewDocumented.push("SOP")
         }
         if (documentsToSet.includes("PDD")) {
          restrictedNewDocumented.push("PDD")
        }
         
        setDocumentTypes(restrictedNewDocumented);
       } 
      } else {
        setDocumentTypes(documentsToSet);
      }
    }
  }, [myBot]);
console.log('botExternalId',myBot);
  const [restrictedUser, setRestrictedUser] = useState([
    "endUser",
    "businessUserRegionWise",
    "businessOwner",
    "firstGfcf",
    "gfcf",
    "firstLevelGPMApprover",
    "GPMapprover",
    "gCad",
    "infosec",
    "landscape"
        
  ]);
  const [allFieldsUserType, setallFieldsUserType] = useState([
    "internalUser",
    "support",
    "releaseManager",
    "editAccess",
    "admin",
  ]);

  const [editUser, setEditUser] = useState([
    "internalUser",
    "admin",
    "qrManager",
    "releaseManager",
    "supportStatus",
  ]);

  const [botModal, setbotModal] = useState(false);
  const [Loading, setLoading] = useState(true);
  const [bots, setBots] = React.useState([]);
  const [successModal, setSuccessModal] = React.useState(false);
  const [documentDropdown, setDocumentDropdown] = React.useState(false);
  const [selectedDropdown, setSelectedDropdown] = React.useState("sopDocument");
  const [similarBots, setSimilarBots] = React.useState([]);
  const [currentDocumentExtension, setCurrentDocumentExtension] =
    React.useState("pdf");
  const [searchResults, setSearchResults] = React.useState(false);
  const [documentEditState, setDocumentEditState] = React.useState(false)
  const [editedDocument, setEditedDocument]  = React.useState("")
  const [editLoader, setEditLoader] = React.useState(false)
  const [ invalidModal ,setInvalidModal ] = React.useState(false)
 

  React.useEffect(() => {
   //console.log(currentDocumentExtension, "currentDocument")
  }, [currentDocumentExtension])

  let auth = _.get(JSON.parse(localStorage.getItem("auth")), "data", "");
  const openDocumentSelector = () => {
    setDocumentDropdown(!documentDropdown);
  };

  const [authData, setAuthData] = useState("");
  React.useEffect(async () => {
    let authCheck = _.get(JSON.parse(localStorage.getItem("auth")), "data", "");

    let expiryStatus = await props.checkExpiry(authCheck);

    if (expiryStatus) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      fetchbot(auth);
    } else {
      setLoading(false);
      props.sessionTimeOutCheck(true);
    }

    if (router.query.searchResults) {
      setSearchResults(true);
    }
  }, [router.query]);

  const fetchbot = async (auth) => {
    setAuthData(auth);
    if (router.query.botID) {
      let authCheck = await JSON.parse(localStorage.getItem("auth")).data;

      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        
    

      axios({
        method: "get",
        url: `${endpoints.baseUrl}/bot/getBotUsingId?botID=${window.atob(router.query.botID)}`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          //   console.log(res.data.data, "data bot from response");
          if (
            res.data.data 
          )  {
            if (res.data.data.dateOfStatusChanged) {
            
              res.data.data.dateOfStatusChanged = res.data.data.dateOfStatusChanged.slice(0, 10);
            }
            
          }

          setMyBot(res.data.data);
          let initialExtensionAr = res.data.data.sopDocument.split(".")
          
          //console.log(initialExtensionAr, "initialExtensionAr");

          dispatch(saveCurrentBot(res.data.data));
          setLoading(false);
          if (initialExtensionAr.length > 1) {
            setCurrentDocumentExtension(
              initialExtensionAr[initialExtensionAr.length - 1]
            );
          }

          if (res.data.data && (res.data.data.documentLink || res.data.data.path)) {
            setEditedDocument(res.data.data.documentLink ? res.data.data.documentLink : res.data.data.path)
          }
          // fetching similar bots
          axios({
            method: "get",
            url: `${endpoints.baseUrl}/elastic/searchQuery`,
            params: { leadPlatform: res.data.data.leadPlatform },
            headers: {
              Authorization: `${auth.accessToken}|${auth.email}`,
            },
          }).then((resp) => {
            if (resp.data.code == 200) {
              //console.log( "response of similar bots elastic")

              setSimilarBots(resp.data.data.allBots.filter((item) => item._source.botID != res.data.data.botID));

              // dispatch(saveBotsAction({ data: resp.data.data, filter: "filter" }));
            } else if (resp.data.code == 403) {
              localStorage.removeItem("auth");
              sessionStorage.clear();
              // router.push("/login");
              setLoading(false)
              props.sessionTimeOutCheck(true);
            }
          });
        } else if (res.data.code == 403) {
          localStorage.removeItem("auth");
          sessionStorage.clear();
          // router.push("/login");
          setLoading(false)
          props.sessionTimeOutCheck(true);
        }
      });
    }
    else {
      setLoading(false)
      props.sessionTimeOutCheck(true)
    } 
    }
  };

  const frameRef = React.useRef(null);

  React.useEffect(() => {
    if (props.type == "previewPage") {
      setMyBot(props.myBot);
      setLoading(false);
      let initialExtensionAr = props.myBot.sopDocument.split(".")
      //console.log(initialExtensionAr, "initialExtensionAr");
      if (initialExtensionAr.length > 1) {
        setCurrentDocumentExtension(
          initialExtensionAr[initialExtensionAr.length - 1]
        );
      }
    }

    // var iframe = document.getElementById("youriframe");

    // setTimeout(() => {
    //   if (iframe) {
    //     iframe.src = iframe.src;
    //   }
    // }, 2000);
    if (frameRef.current != null) {
      frameRef.current.contentWindow.location.reload();
    }

    //console.log(document.getElementById("youriframe"), "youriframe");
    //console.log(frameRef, "youriframe");
  }, []);

  const getBot = () => {
    let modal = !botModal;
    setbotModal(true);

    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };

  const editBot = () => {
    router.push("/editBot");
  };

  const gotDropDownValue = (value, dropdownParent, haveRelated) => {
    // console.log(documentAr, "DOCUMENTAR")
    // console.log(value,"valueee")
    let selectedDocument = documentAr.filter(
      (item, index) => item.title == value
    );
    // console.log(selectedDocument[0].value, "selected Dropdown")
    setSelectedDropdown(selectedDocument[0].value);
    //console.log(myBot[selectedDocument[0].value], "ye value check karne ka");
    //console.log(myBot[selectedDocument[0].value], "valueeeeesss");
    let extensionAr = myBot[selectedDocument[0].value].split(".")
    let extension = extensionAr[extensionAr.length - 1];
    setCurrentDocumentExtension(extension);
    setDocumentDropdown(false);
  };

  function camelize(str) {
    if (str === undefined) {
      return null;
    } else {
      return str
        .toString()
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
          return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, "");
    }
  }

  const fixCountry = (str) => {
    let fixedString = "";

    if (props.type == "previewPage") {
      //     for (let i in str) {
      //       if (i != str.length-1){
      //         fixedString = fixedString + str[i] + ", ";
      //       }
      //       else {
      //         fixedString = fixedString+ str[i]
      //       }
      //     }
    } else {
      if (str.includes(";")) {
        str.replace(";", ",");
      }
    }

    if (fixedString[fixedString.length - 1] == ",") {
      fixedString = fixedString.slice(0, fixedString.length - 1);
    }

    return fixedString;
  };





  const changeDocumentLink = async () => {
   //console.log(editedDocument, "editedDocument")

   if (editedDocument.trim()){
   
    setEditLoader(true)
    let auth = await JSON.parse(localStorage.getItem("auth")).data;
 
       let expiryStatus = await props.checkExpiry(auth);
 
       if (expiryStatus) {
    let res = await axios({
      method : "PUT",
      data : {
        botID : myBot.botID,
        newDocumentLink : editedDocument
      },
      url :`${endpoints.baseUrl}/bot/editDocumentLink`,
      headers: {
       Authorization: `${auth.accessToken}|${auth.email}`,
     },
    })
    setMyBot(res.data.data);
    let initialExtensionAr = res.data.data.sopDocument.split(".")
    
    //console.log(initialExtensionAr, "initialExtensionAr");
 
    dispatch(saveCurrentBot(res.data.data));
    setDocumentEditState(false)
    setEditLoader(false)
    
   }
 
 else {
   setLoading(false)
   props.sessionTimeOutCheck(true)
   
 }
   }
   else {
     setInvalidModal(true)
   }
  
  }

  const [isURLCopied, setIsURLCopied] = React.useState(false);
  const handleCopyurl = () => {
    const urlToCopy = window.location.href;
    const clipboard = new ClipboardJS('.copy-button', {
      text: () => urlToCopy,
    });
    clipboard.on('success', (e) => {
      e.clearSelection();
      setIsURLCopied(true)
      // alert('URL copied to clipboard >>>>>>>>>>>>>>>>>>>>>>---------', urlToCopy);
    });
    clipboard.on('error', (e) => {
      console.error('Failed to copy URL: ', e.action);
    });
  };
  return (
    <>
      {successModal ? <SuccessModal setSuccessModal={setSuccessModal} /> : null}
      {invalidModal ? <SuccessModal setSuccessModal = {setInvalidModal}  title={"Edit document link"}
        message={"Document link cannot be empty"} fail = {true}/> : null}
      {Loading ? (
        <div style={{ height: "800px" }}>
          <Loader />
        </div>
      ) : (
        <>
          {myBot != null ? (
            <div className="container">
              <div className={styles.botDetailWrapper}>
                <div className={styles.detailHead}>
                  <div className={styles.cardHead}>
                    <div className={styles.left}>
                    <span
                            className={styles.rollBot}
                            onClick={() => {
                              router.push("/botStore");
                            }}
                          >
                            <img src={'/assets/less-than.png'} />
                          </span>
                      <div className={styles.icon}>
                        <Icons
                          name={camelize(myBot.leadPlatform)}
                          className={styles.shoppingIcon}
                        />
                      </div>
                      <div className={styles.text}>
                        <div className={styles.flexd}>
                            <div>
                             <p className={styles.code}>{(props.createBot)?'':myBot.botExternalId}</p> 
                            </div>
                            {(props.createBot)?'':myBot.requestType =="Roll Out" &&
                              <div className={styles.list}>
                                <span class={styles.tooltiptext}>{'Bot_Id'} . {'Landscape_Id'} . {'Variant_Id'}</span>
                                <sapn className={styles.info}>i</sapn> 
                              </div>}
                        </div>
                        <p className={styles.label}>{myBot.leadPlatform}</p>
                      </div>
                      <div className={styles.statusTagWrapper}>
                        <p
                          className={`${styles.label} ${
                            styles[
                              `${
                                status == "Design/Feasibility"
                                  ? "designFeasibility"
                                  : camelize(myBot.status)
                              }Status`
                            ]
                          }`}
                        >
                          {myBot.status}
                        </p>
                      </div>
              <button onClick={handleCopyurl} className="copy-button ms-3 " style={{fontSize:"30px"}}>{isURLCopied ? <AiOutlineCheck/> : <AiOutlineCopy />}</button>
 
                   </div>
                    {props.type == "previewPage" ? null : (
                      <div className={styles.right}>
                        {/* {searchResults ? (
                          <span
                            className={styles.backBotSearch}
                            onClick={() => {
                              router.push("/globalSearch");
                            }}
                          >
                            Back to Search Results
                          </span>
                        ) : (
                          <span
                            className={styles.backBot}
                            onClick={() => {
                              router.push("/botStore");
                            }}
                          >
                            Back to Bot List
                          </span>
                        )} */}
                        {!restrictedViewDetails ? 
                          <div className="flex items-center gap-3">
                             {myBot.requestType === "New Request" && (
                              <span
                                className="!border !border-green-600 text-green-600 cursor-pointer h-full px-2 flex justify-center items-center"
                                onClick={() => {
                                  router.push(
                                    `/change-request?botID=${myBot.botID}`
                                  );
                                }}
                              >
                                Create Change Request Bot
                              </span>
                            )}
                             {myBot.requestType!=="Roll Out" && <span className={styles.backBot} onClick={() => {
                              router.push("/rolloutBot");
                                }}>
                              Create Roll Out Bot
                            </span>}
                          </div>
                         : null}
                        <span className={styles.getBot} onClick={getBot}>
                          Get This Bot
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className={styles.detailBody}>
                  <div className={styles.textualContent}>
                    <div className={styles.txtCard}>
                      <div className={`${styles.cardRow} ${styles.fullwidth}`}>
                        <div className={styles.center}>
                          <p> PROCESS NAME</p>
                          <h4>{myBot.processName}</h4>
                        </div>
                      </div>
                      <div className={`${styles.cardRow} ${styles.fullwidth}`}>
                        <div className={styles.left}>
                          <p>Area</p>
                          <h5>{myBot.area}</h5>
                        </div>
                        <div className={styles.right}>
                          <p>Sub Area</p>
                          <h5>{myBot.subArea}</h5>
                        </div>
                      </div>


                      <div className={`${styles.cardRow} ${styles.fullwidth}`}>
                        <div className={styles.left}>
                          <p>Domain</p>
                          <h5>{myBot?.domain || "-"}</h5>
                        </div>
                        <div className={styles.right}>
                          <p>Family</p>
                          <h5>{myBot?.family || "-"}</h5>
                        </div>
                      </div>

                      <div className={`${styles.cardRow} ${styles.fullwidth}`}>
                        <div className={styles.left}>
                          <p>Product</p>
                          <h5>{myBot?.product || "-"}</h5>
                        </div>
                      </div>                     


                      <div className={`${styles.cardRow} ${styles.fullwidth}`}>
                        <div className={styles.center}>
                          <p>PROCESS DESCRIPTION</p>
                          <h5>
                            {myBot.processDescription}{" "}
                            {associateBotIds.length > 0
                              ? `This bot is associated with ${associateBotIds.map((item) => item.botExternalId).join(", ")} bots.`
                              : null}
                          </h5>
                        </div>
                      </div>

                                 {/* Associated Bot Ids */}

                       <AssociateBots
                        parentBotID={myBot?.botExternalId}
                        setAssociateBotIds={setAssociateBotIds}
                      />

                      <div className={`${styles.cardRow}`}>
                        <div className={styles.left}>
                          <p>Cluster</p>
                          <h5>{myBot.cluster}</h5>
                        </div>
                        <div className={styles.right}>
                          <p>MCO</p>
                          {props.type == "previewPage" &&
                          typeof myBot.mco != "string" &&
                          myBot.mco != null ? (
                            <h5>
                              {_.get(myBot, "mco", []).map(
                                (item, index) => (
                                  <span>
                                    {item}{" "}
                                    {index == myBot.mco.length - 1
                                      ? null
                                      : ","}
                                  </span>
                                )
                              )}
                            </h5>
                          ) : (
                            <h5>{myBot.mco}</h5>
                          )}
                          {/* <h5>{myBot.mco}</h5> */}
                        </div>
                      </div>
                      <div className={`${styles.cardRow}`}>
                        <div className={styles.left}>
                          <p>COUNTRY</p>
                          {props.type == "previewPage" &&
                          typeof myBot.country != "string" &&
                          myBot.country != null ? (
                            <h5>
                              {_.get(myBot, "country", []).map(
                                (item, index) => (
                                  <span>
                                    {item}{" "}
                                    {index == myBot.country.length - 1
                                      ? null
                                      : ","}
                                  </span>
                                )
                              )}
                            </h5>
                          ) : (
                            <h5>{myBot.country}</h5>
                          )}
                        </div>
                        <div className={styles.right}>
                          <p>TECHNOLOGY</p>
                          <h5>{myBot.technology}</h5>
                        </div>
                      </div>

                       <div className={`${styles.cardRow}`}>
                        <div className={styles.left}>
                          <p>ET Profile</p>
                          <h5>{myBot?.eTProfile}</h5>
                        </div>
                        <div className={styles.left}>
                          <p>Platform</p>
                          <h5>{myBot?.platform}</h5>
                        </div>
                      </div>

                      <div className={`${styles.cardRow}`}>
                        <div className={styles.left}>
                          <p>KFAS</p>
                          <h5>{myBot.kfa ? "Yes" : "No"}</h5>
                        </div>
                      </div>

                      <div className={`${styles.cardRow}`}>
                        <div className={styles.left}>
                          <p>KFAS TYPE</p>
                          <h5>
                            {myBot.kfaTransactional
                              ? "Transactional"
                              : myBot.kfaInformational
                              ? "Informational"
                              : "None"}
                          </h5>
                        </div>
                        <div className={styles.right}>
                          <p>PROCESS CRITICALITY</p>
                          <h5>{myBot.processCriticality}</h5>
                        </div>
                      </div>

                      <div className={`${styles.cardRow}`}>
                        <div className={styles.left}>
                          <p>REQUESTER E-MAIL ID</p>
                          <h5>{myBot.requesterEmailID}</h5>
                        </div>
                        <div className={styles.right}>
                          <p>T CODE</p>
                          <h5>{myBot.tCode == "NA" ? "--" : myBot.tCode}</h5>
                        </div>
                      </div>

                      <div className={`${styles.cardRow}`}>
                        <div className={styles.left}>
                          <p>CREATED BY</p>
                          {props.type == "previewPage" ? (
                            <h5>{auth.name}</h5>
                          ) : (
                            <h5>{myBot.createdBy}</h5>
                          )}
                        </div>

                        <div className={styles.right}>
                          <p>BUSINESS OWNER E-MAIL ID</p>
                          <h5>
                            {myBot.businessOwnerEmailID == "NA"
                              ? "--"
                              : myBot.businessOwnerEmailID}
                          </h5>
                        </div>
                      </div>

                      <div className={`${styles.cardRow}`}>
                        <div className={styles.left}>
                          <p>Cost Approver</p>
                          <h5>
                            {myBot.costApprover == null
                              ? "--"
                              : myBot.costApprover}
                          </h5>
                        </div>
                      </div>                       

                      <div className={`${styles.cardRow}`}>
                        <div className={styles.left}>
                          <p>HAP DELIVERY LEADS</p>
                          <h5>{myBot.engagementLead}</h5>
                        </div>
                        <div className={styles.right}>
                          <p>Catalogue Products</p>
                          <h5>{myBot.catalogueProducts ? "Yes" : "No"}</h5>
                        </div>
                      </div>

                        <div className={`${styles.cardRow}`}>
                        <div className={styles.left}>
                          <p>Business Analyst</p>
                          <h5>{myBot.businessAnalyst}</h5>
                        </div>
                        <div className={styles.right}>
                          <p>Functional HAP SMEs</p>
                          <h5>{myBot.functionalHAPSMEs}</h5>
                        </div>
                      </div>

                      {restrictedUserDocumentView.includes(
                        auth.userType
                      ) ? null : (
                        <div
                          className={`${styles.cardRow} ${styles.fullwidth}`}
                        >
                          {myBot.documentLink || myBot.path ? (
                            <div className={styles.center}>
                            <div className = {styles.documentLinkHeading}>
                              <p>DOCUMENT LINKS</p>
                             { documentEditState || auth.userType != "admin" ? null :  <span onClick = {() => setDocumentEditState(true)}> <Icons
                                  name="pencilDark"
                                  className={styles.editInactive}
                                /></span>}
                              </div>
                              { 
                                documentEditState ? 
                                <div className = {styles.editRow}>
                                <input onChange={(e) => setEditedDocument(e.target.value)} value = {editedDocument} type="text"/>
                               
                               {editLoader ? 
                                <div className={`${styles.container}`}>
            <div className={`${styles.loader} ${styles.loader3}`}></div>
        </div>
        :
         <button onClick = {changeDocumentLink}>Save</button> }
                                </div>
                                :
                                myBot.documentLink ? (
                                <h5>
                                  <a
                                    target="_blank"
                                    href={`${myBot.documentLink}`}
                                  >
                                    {myBot.documentLink}
                                  </a>
                                </h5>
                              ) : (
                                <h5>
                                  <a target="_blank" href={`${myBot.path}`}>
                                    {myBot.path}
                                  </a>
                                </h5>
                              )}
                            </div>
                          ) : null}
                        </div>
                      )}
                      {restrictedViewDetails ? (
                        <></>
                      ) : (
                        <>
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>TOOL USED</p>
                              <h5>{myBot.toolUsed}</h5>
                            </div>
                            <div className={styles.right}>
                              <p>APPLICATIONS</p>
                              <h5>{myBot.applications}</h5>
                            </div>
                          </div>
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>DATE LOGGED</p>
                              <h5>
                                {convertToDDMMYYYY(
                                  myBot.dateLogged == "2018-12-31" ||
                                    myBot.dateLogged == "2018-12-30"
                                    ? ""
                                    : myBot.dateLogged
                                )}
                              </h5>
                            </div>
                            <div className={styles.right}>
                              <p>DELIVERY MODEL</p>
                              <h5>{myBot.deliveryModel}</h5>
                            </div>
                          </div>

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>REQUEST TYPE</p>
                              <h5>{myBot.requestType}</h5>
                            </div>
                           
                          </div>

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>PARENT BOT ID</p>
                              <h5>
                                 {myBot.botType === "rollout"
                                  ? myBot.masterBotID
                                  : myBot.parentBotID
                                  ? myBot.parentBotID
                                  : "--"}
                              </h5>
                            </div>
                            <div className={styles.right}>
                              <p>HOURS SAVED YEARLY</p>
                              <h5>
                                {myBot.hoursSavedYearly == "NA"
                                  ? "--"
                                  : myBot.hoursSavedYearly}
                              </h5>
                            </div>
                          </div>

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>INITIATED BY</p>
                              <h5>{myBot.initiatedBy}</h5>
                            </div>
                            <div className={styles.right}>
                              <p>DATE OF STATUS CHANGED</p>
                              {/* <h5>
                                {convertToDDMMYYYY(
                                  myBot.dateOfStatusChanged == "2018-12-31" ||
                                    myBot.dateOfStatusChanged == "2018-12-30"
                                    ? ""
                                    : myBot.dateOfStatusChanged
                                )}
                              </h5> */}
                            </div>
                          </div>

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.center}>
                              <p>COMMENTS FOR STATUS CHANGED</p>
                              <h5>{myBot.commentsForStatusChanged ? myBot.commentsForStatusChanged : "--"}</h5>
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    {!restrictedViewDetails ? (
                      <>
                        <div className={styles.txtCard}>
                          <h1 className={styles.cardHeading}>
                            Supporting Details
                          </h1>

                          <div
                            className={`${styles.cardRow}`}
                          >
                            <div className={styles.left}>
                              <p>Process ID</p>
                              <h5>{myBot.processID}</h5>
                            </div>
                            <div className={styles.right}>
                              <p>SAP ID</p>
                              <h5>{myBot.sAPID ? myBot.sAPID : "--"}</h5>
                            </div>
                          </div>

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>DATA CLASSIFICATION</p>
                              <h5>{myBot.dataClassification}</h5>
                            </div>
                            <div className={styles.right}>
                              <p>REMARKS</p>
                              <h5>{myBot.remarks}</h5>
                            </div>
                          </div>
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>BUILD NAME</p>
                              <h5>{myBot.buildName}</h5>
                            </div>
                            <div className={styles.right}>
                              <p>SUPPORT STATUS</p>
                              <h5>{myBot.supportStatus}</h5>
                            </div>
                          </div>

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>NUMBER OF RUNS IN A MONTH</p>
                              <h5>{myBot.numberOfRunsInAMonth}</h5>
                            </div>
                            <div className={styles.right}>
                              <p>AVERAGE RUNNING TIME</p>
                              <h5>{myBot.averageTime}</h5>
                            </div>
                          </div>
                        </div>

                        <div className={styles.txtCard}>
                          <h1 className={styles.cardHeading}>
                            BOT delivery dates
                          </h1>



                          <div className={`${styles.cardRow}`}>
                        
                            <div className={styles.left}>
                              <p>PDD SIGN OFF DATE</p>
                              
                              <h5>
                                {convertToDDMMYYYY(
                                  myBot.pddSignOffDate == "2018-12-30" || myBot.pddSignOffDate == "2018-12-31"
                                    ? ""
                                    : myBot.pddSignOffDate
                                )}
                              </h5>
                            </div>
                          </div>

                          <div className={`${styles.cardRow}`}>
                            

                            <div className={styles.left}>
                              <p>Bau Date</p>
                              <h5>
                                {convertToDDMMYYYY(
                                  myBot.bauDate == "2018-12-31" || myBot.bauDate == "2018-12-30"
                                    ? ""
                                    : myBot.bauDate
                                )}
                              </h5>
                            </div>
                          </div>
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>Last Modified DATE</p>
                              
                              <h5>
                                {convertToDDMMYYYY(
                                  myBot.lastModifiedDate == "2018-12-30" || myBot.lastModifiedDate == "2018-12-31"
                                    ? ""
                                    : myBot.lastModifiedDate
                                )}
                              </h5>
                            </div>

                            <div className={styles.right}>
                              <p>UAT SIGN OFF DATE</p>
                              <h5>
                                {convertToDDMMYYYY(
                                  myBot.uATSignOffDate == "2018-12-30" || myBot.uATSignOffDate == "2018-12-31"
                                    ? ""
                                    : myBot.uATSignOffDate
                                )}
                              </h5>
                            </div>
                          </div>

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>GO LIVE DATE</p>
                              
                              <h5>
                                {convertToDDMMYYYY(
                                  myBot.goLiveDate == "2018-12-30" || myBot.goLiveDate == "2018-12-31"
                                    ? ""
                                    : myBot.goLiveDate
                                )}
                              </h5>
                            </div>
                          </div>
                        </div>

                        <div className={styles.txtCard}>
                          <h1 className={styles.cardHeading}>Approvals</h1>

                          <div className={`${styles.cardRow}`}>
                          <div className={styles.left}>
                              <p>LANDSCAPE APPROVAL</p>
                              <h5>
                                { 
                                
                                myBot.landscapeApproval ? "Yes" :
                                myBot.landscapeApproval === false ? "No" : "--"
                                  }
                                {/*{ 
                                
                                myBot.landscapeApprovalStatuss ? "Approved" :
                                myBot.landscapeApprover === undefined ||
                                myBot.landscapeApprover == "" ||
                                myBot.landscapeApprover == null ?
                                
                                   "--"
                                  :"Rejected"
                                  }*/}
                              </h5>
                            </div>

                         

                            <div className={styles.right}>
                              <p>LANDSCAPE APPROVER NAME</p>
                              <h5>
                                {myBot.landscapeApprover === undefined ||
                                myBot.landscapeApprover == "" ||
                                myBot.landscapeApprover == null ?
                                
                                   "--"
                                  : myBot.landscapeApprover}
                              </h5>
                            </div>
                          </div>

                          <div className={`${styles.cardRow}`}>
                           {/* <div className={styles.left}>
                              <p>LANDSCAPE APPROVAL DATE</p>
                              <h5>
                                {myBot.landscapeApprovalDate ===
                                  undefined ||
                                myBot.landscapeApprovalDate == "" ||
                                myBot.landscapeApprovalDate == null ||
                                myBot.landscapeApprovalDate ==
                                  "2018-12-31" ||
                                myBot.landscapeApprovalDate == "2018-12-30"
                                  ? "--"
                                  :  convertToDDMMYYYY(myBot.landscapeApprovalDate)}
                              </h5>
                            </div>*/}

                          {/*  <div className={styles.right}>
                              <p>LANDSCAPE COMMENTS</p>
                              <h5>
                                {myBot.landscapeComments === undefined ||
                                myBot.landscapeComments == "" ||
                                myBot.landscapeComments == null 
                                  ? "--"
                                  : myBot.landscapeComments}
                              </h5>
                            </div>*/}
                          </div>

                          {myBot.landscapeApprovalDocumentLink ? 
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.center}>
                              <p>LANDSCAPE APPROVAL DOCUMENT LINK</p>
                              <h5>
                                
                                  <a
                                    target="_blank"
                                    href={`${endpoints.fetchBlobUrl}/${myBot.landscapeApprovalDocumentLink}`}
                                  >{`${endpoints.fetchBlobUrl}/${myBot.landscapeApprovalDocumentLink}?${sasToken}`}</a>
                                
                              </h5>
                            </div>
                          </div> : null }
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>INFOSEC APPROVAL STATUS</p>
                              <h5>
                                {/*{ 
                                
                                myBot.infosecApproval ? "Approved" :
                                myBot.infosecApproval === false ? "Rejected" : "--"
                                  }*/}
                                { 
                                
                                myBot.infosecApproval ? "Approved" :
                               myBot.infosecApprover === undefined ||
                                myBot.infosecApprover == "" ||
                                myBot.infosecApprover == null ?
                                
                                   "--"
                                  : "Rejected"
                                  }
                              </h5>
                            </div>

                         

                            <div className={styles.right}>
                              <p>INFOSEC APPROVER NAME</p>
                              <h5>
                                {myBot.infosecApprover === undefined ||
                                myBot.infosecApprover == "" ||
                                myBot.infosecApprover == null ?
                                
                                   "--"
                                  : myBot.infosecApprover}
                              </h5>
                            </div>
                          </div>

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>INFOSEC APPROVAL DATE</p>
                              <h5>
                                {myBot.infosecApprovalDate ===
                                  undefined ||
                                myBot.infosecApprovalDate == "" ||
                                myBot.infosecApprovalDate == null ||
                                myBot.infosecApprovalDate ==
                                  "2018-12-31" ||
                                myBot.infosecApprovalDate == "2018-12-30"
                                  ? "--"
                                  :  convertToDDMMYYYY(myBot.infosecApprovalDate)}
                              </h5>
                            </div>

                            <div className={styles.right}>
                              <p>INFOSEC COMMENTS</p>
                              <h5>
                                {myBot.infosecComments === undefined ||
                                myBot.infosecComments == "" ||
                                myBot.infosecComments == null 
                                  ? "--"
                                  : myBot.infosecComments}
                              </h5>
                            </div>
                          </div>

                          {myBot.infosecApprovalDocumentLink ? 
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.center}>
                              <p>INFOSEC APPROVAL DOCUMENT LINK</p>
                              <h5>
                                
                                  <a
                                    target="_blank"
                                    href={`${endpoints.fetchBlobUrl}/${myBot.infosecApprovalDocumentLink}`}
                                  >{`${endpoints.fetchBlobUrl}/${myBot.infosecApprovalDocumentLink}?${sasToken}`}</a>
                                
                              </h5>
                            </div>
                          </div> : null }

                          {/* <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>LANDSCAPE APPROVAL</p>
                              <h5>
                                {myBot.landscapeApproval == null ||
                                myBot.landscapeApproval == undefined
                                  ? "--"
                                  : myBot.landscapeApproval &&
                                    myBot.landscapeApproval != "No"
                                  ? "Yes"
                                  : "No"}
                              </h5>
                            </div>
                            <div className={styles.right}>
                              <p>LANDSCAPE APPROVER</p>
                              <h5>
                                {myBot.landscapeApprover == ""
                                  ? "--"
                                  : myBot.landscapeApprover}
                              </h5>
                            </div>
                          </div> */}

                          {/* <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>INFOSEC APPROVAL</p>
                              <h5>
                                {myBot.infosecApproval == null ||
                                myBot.infosecApproval == undefined
                                  ? "--"
                                  : myBot.infosecApproval &&
                                    myBot.infosecApproval != "No"
                                  ? "Yes"
                                  : "No"}
                              </h5>
                            </div>
                            <div className={styles.right}>
                              <p>INFOSEC APPROVER</p>
                              <h5>
                                {myBot.infosecApprover == ""
                                  ? "--"
                                  : myBot.infosecApprover}
                              </h5>
                            </div>
                          </div> */}

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>FIRST LEVEL GPM APPROVAL STATUS</p>
                              <h5>
                                { 
                                
                                myBot.firstLevelGpmApprovalStatus ? "Approved" :
                                myBot.firstLevelGpmApprovalStatus === false ? "Rejected" : "--"
                                  }
                              </h5>
                            </div>

                         

                            <div className={styles.right}>
                              <p>FIRST LEVEL GPM APPROVER NAME</p>
                              <h5>
                                {myBot.firstLevelGpmApprover === undefined ||
                                myBot.firstLevelGpmApprover == "" ||
                                myBot.firstLevelGpmApprover == null ?
                                
                                   "--"
                                  : myBot.firstLevelGpmApprover}
                              </h5>
                            </div>
                          </div>

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>FIRST LEVEL GPM APPROVAL DATE</p>
                              <h5>
                                {myBot.firstLevelGpmApprovalDate ===
                                  undefined ||
                                myBot.firstLevelGpmApprovalDate == "" ||
                                myBot.firstLevelGpmApprovalDate == null ||
                                myBot.firstLevelGpmApprovalDate ==
                                  "2018-12-31" ||
                                myBot.firstLevelGpmApprovalDate == "2018-12-30"
                                  ? "--"
                                  :  convertToDDMMYYYY(myBot.firstLevelGpmApprovalDate)}
                              </h5>
                            </div>

                            <div className={styles.right}>
                              <p>FIRST LEVEL GPM COMMENTS</p>
                              <h5>
                                {myBot.firstLevelGpmComment === undefined ||
                                myBot.firstLevelGpmComment == "" ||
                                myBot.firstLevelGpmComment == null 
                                  ? "--"
                                  : myBot.firstLevelGpmComment}
                              </h5>
                            </div>
                          </div>

                          {myBot.firstLevelGpmApprovalDocumentLink ? 
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.center}>
                              <p>FIRST LEVEL GPM APPROVAL DOCUMENT LINK</p>
                              <h5>
                                
                                  <a
                                    target="_blank"
                                    href={`${endpoints.fetchBlobUrl}/${myBot.firstLevelGpmApprovalDocumentLink}`}
                                  >{`${endpoints.fetchBlobUrl}/${myBot.firstLevelGpmApprovalDocumentLink}?${sasToken}`}</a>
                                
                              </h5>
                            </div>
                          </div> : null }

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>SECOND LEVEL GPM APPROVAL STATUS</p>
                              <h5>
                                { 
                                myBot.secondLevelGpmApprovalStatus ? "Approved" : 
                                 myBot.secondLevelGpmApprovalStatus === false ? "Rejected" : "--"
                                  }
                              </h5>
                            </div>
                            <div className={styles.right}>
                              <p> SECOND LEVEL GPM APPROVER NAME</p>
                              <h5>
                                {myBot.secondLevelGpmApprover === undefined ||
                                myBot.secondLevelGpmApprover == "" ||
                                myBot.secondLevelGpmApprover == null 
                                  ? "--"
                                  : myBot.secondLevelGpmApprover}
                              </h5>
                            </div>
                          </div>

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>SECOND LEVEL GPM APPROVAL DATE</p>
                              <h5>
                                {myBot.secondLevelGpmApprovalDate ===
                                  undefined ||
                                myBot.secondLevelGpmApprovalDate == "" ||
                                myBot.secondLevelGpmApprovalDate == null ||
                                myBot.secondLevelGpmApprovalDate ==
                                  "2018-12-31" ||
                                myBot.secondLevelGpmApprovalDate == "2018-12-30"
                                  ? "--"
                                  : convertToDDMMYYYY(myBot.secondLevelGpmApprovalDate)}
                              </h5>
                            </div>

                            <div className={styles.right}>
                              <p>SECOND LEVEL GPM COMMENTS</p>
                              <h5>
                                {myBot.secondLevelGpmComment === undefined ||
                                myBot.secondLevelGpmComment == "" ||
                                myBot.secondLevelGpmComment == null 
                                  ? "--"
                                  : myBot.secondLevelGpmComment}
                              </h5>
                            </div>
                          </div>

                          
                          {myBot.secondLevelGpmApprovalDocumentLink ? 
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.center}>
                              <p>SECOND LEVEL GPM APPROVAL DOCUMENT LINK</p>
                              <h5>
                                
                                  <a
                                    target="_blank"
                                    href={`${endpoints.fetchBlobUrl}/${myBot.secondLevelGpmApprovalDocumentLink}`}
                                  >{`${endpoints.fetchBlobUrl}/${myBot.secondLevelGpmApprovalDocumentLink}?${sasToken}`}</a>
                                
                              </h5>
                            </div>
                          </div> : null }

                          { myBot.kfa == true ? (
                            <div>
                              <div className={`${styles.cardRow}`}>
                                <div className={styles.left}>
                                  <p>FIRST LEVEL GFCF APPROVAL STATUS</p>
                                  <h5>
                                    { 
                                    
                                    
                                    myBot.firstLevelgfcfApprovalStatus ? "Approved" :
                                    myBot.firstLevelgfcfApprovalStatus === false ? "Rejected" : "--" 
                                    }
                                  </h5>
                                </div>

                                <div className={styles.right}>
                                  <p>FIRST LEVEL GFCF APPROVER NAME</p>
                                  <h5>
                                    {myBot.firstLevelgfcfApprover == "" ||
                                    myBot.firstLevelgfcfApprover == undefined ||
                                    myBot.firstLevelgfcfApprover == null
                                      ? "--"
                                      : myBot.firstLevelgfcfApprover}
                                  </h5>
                                </div>
                              </div>

                              <div className={styles.cardRow}>
                                <div className={styles.left}>
                                  <p>FIRST LEVEL GFCF APPROVAL DATE</p>
                                  <h5>
                                    {myBot.firstLevelGfcfApprovalDate ==
                                      "2018-12-31" ||
                                    myBot.firstLevelGfcfApprovalDate ==
                                      "2018-12-30" ||
                                    myBot.firstLevelGfcfApprovalDate ===
                                      undefined ||
                                    myBot.firstLevelGfcfApprovalDate === null
                                      ? "--"
                                      : convertToDDMMYYYY(myBot.firstLevelGfcfApprovalDate)}
                                  </h5>
                                </div>
                                <div className={styles.right}>
                                  <p>FIRST LEVEL GFCF COMMENTS</p>
                                  <h5>
                                    {myBot.firstLevelGfcfComment == "" ||
                                    myBot.firstLevelGfcfComment === undefined ||
                                    myBot.firstLevelGfcfComment == null
                                      ? "--"
                                      : myBot.firstLevelGfcfComment}
                                  </h5>
                                </div>
                              </div>


                                
                          {myBot.firstLevelGfcfApprovalDocumentLink ? 
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.center}>
                              <p>FIRST LEVEL GFCF APPROVAL DOCUMENT LINK</p>
                              <h5>
                                
                                  <a
                                    target="_blank"
                                    href={`${endpoints.fetchBlobUrl}/${myBot.firstLevelGfcfApprovalDocumentLink}`}
                                  >{`${endpoints.fetchBlobUrl}/${myBot.firstLevelGfcfApprovalDocumentLink}?${sasToken}`}</a>
                                
                              </h5>
                            </div>
                          </div> : null }

                              <div className={`${styles.cardRow}`}>
                                <div className={styles.left}>
                                  <p> SECOND LEVEL GFCF APPROVAL STATUS</p>
                                  <h5>
                                    {
                                    myBot.secondLevelGfcfApprovalStatus ? "Approved" :
                                    myBot.secondLevelGfcfApprovalStatus === false ? "Rejected" : "--"
                                      }
                                  </h5>
                                </div>

                                <div className={styles.right}>
                                  <p> SECOND LEVEL GFCF APPROVER NAME</p>
                                  <h5>
                                    {myBot.secondLevelGfcfApprover ===
                                      undefined ||
                                    myBot.secondLevelGfcfApprover == "" ||
                                    myBot.secondLevelGfcfApprover == null 
                                      ? "--"
                                      : myBot.secondLevelGfcfApprover}
                                  </h5>
                                </div>
                              </div>

                              <div className={styles.cardRow}>
                                <div className={styles.left}>
                                  <p>SECOND LEVEL GFCF APPROVAL DATE </p>
                                  <h5>
                                    {myBot.secondLevelGfcfApprovalDate ===
                                      undefined ||
                                    myBot.secondLevelGfcfApprovalDate == "" ||
                                    myBot.secondLevelGfcfApprovalDate == null ||
                                    myBot.secondLevelGfcfApprovalDate ==
                                      "2018-12-31" ||
                                    myBot.secondLevelGfcfApprovalDate ==
                                      "2018-12-30"
                                      ? "--"
                                      : convertToDDMMYYYY(myBot.secondLevelGfcfApprovalDate)}
                                  </h5>
                                </div>
                                <div className={styles.right}>
                                  <p>SECOND LEVEL GFCF COMMENTS </p>
                                  <h5>
                                    {myBot.secondLevelGfcfComment ===
                                      undefined ||
                                    myBot.secondLevelGfcfComment == "" ||
                                    myBot.secondLevelGfcfComment == null
                                    
                                      ? "--"
                                      : myBot.secondLevelGfcfComment}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          
{myBot.secondLevelGfcfApprovalDocumentLink ? 
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.center}>
                              <p>SECOND LEVEL GFCF APPROVAL DOCUMENT LINK</p>
                              <h5>
                                
                                  <a
                                    target="_blank"
                                    href={`${endpoints.fetchBlobUrl}/${myBot.secondLevelGfcfApprovalDocumentLink}`}
                                  >{`${endpoints.fetchBlobUrl}/${myBot.secondLevelGfcfApprovalDocumentLink}?${sasToken}`}</a>
                                
                              </h5>
                            </div>
                          </div> : null }

                          {myBot.cluster == "Global" ? (
                            <>
                              <div className={`${styles.cardRow}`}>
                                <div className={styles.left}>
                                  <p>GCAD APPROVAL STATUS</p>
                                  <h5>
                                    {  
                                    
                                    myBot.gcadApprovalStatus ? "Approved" :
                                       myBot.gcadApprovalStatus === false
                                        ? "Rejected"
                                        : "--"
                                      }
                                  </h5>
                                </div>
                                <div className={styles.right}>
                                  <p>GCAD APPROVER NAME</p>
                                  <h5>{  myBot.gcadApprover ? myBot.gcadApprover : "--"}</h5>
                                </div>
                              </div>
                              <div className={`${styles.cardRow}`}>
                                <div className={styles.left}>
                                  <p>GCAD APPROVAL DATE</p>
                                  <h5>
                                    { myBot.gcadApprovalDate ==
                                      "2018-12-31" ||
                                    myBot.gcadApprovalDate ==
                                      "2018-12-30"
                                      ? "--" : 
                                    myBot.gcadApprovalDate
                                      ? convertToDDMMYYYY(myBot.gcadApprovalDate)
                                      : "--"}
                                  </h5>
                                </div>
                                <div className={styles.right}>
                                  <p>GCAD APPROVER COMMENTS</p>
                                  <h5>
                                    { 
                                       myBot.gcadComments
                                      ? myBot.gcadComments
                                      : "--"}
                                  </h5>
                                </div>
                              </div>
                            </>
                          ) : null}

{myBot.gCadApprovalDocumentLink ? 
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.center}>
                              <p>GCAD APPROVAL DOCUMENT LINK</p>
                              <h5>
                                
                                  <a
                                    target="_blank"
                                    href={`${endpoints.fetchBlobUrl}/${myBot.gCadApprovalDocumentLink}`}
                                  >{`${endpoints.fetchBlobUrl}/${myBot.gCadApprovalDocumentLink}?${sasToken}`}</a>
                                
                              </h5>
                            </div>
                          </div> : null }

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>BUSINESS OWNER COMMENTS</p>
                              <h5>
                                {myBot.businessOwnerComments
                                  ? myBot.businessOwnerComments
                                  : "--"}
                              </h5>
                            </div>
                            <div className={styles.right}>
                              <p>LANDSCAPE NAME</p>
                              <h5>
                                {
                                (myBot.landscapeId!==null && myBot.landscapeId!==undefined)
                                  ? (
                                    (myBot.landscapeId==0)&& "Global" ||
                                    (myBot.landscapeId==1)&& "Fusion" ||
                                    (myBot.landscapeId==2)&& "Sirius" ||
                                    (myBot.landscapeId==3)&& "Cordillera" ||
                                    (myBot.landscapeId==4)&& "U2K2"
                                    )
                                  : "--"}
                              </h5>
                            </div>
                          </div>
                        



                        





                          



                          {myBot.businessOwnerApprovalDocumentLink ? 
                          <div className={`${styles.cardRow}`}>
                            <div className={styles.center}>
                              <p>BUSINESS OWNER APPROVAL DOCUMENT LINK</p>
                              <h5>
                                
                                  <a
                                    target="_blank"
                                    href={`${endpoints.fetchBlobUrl}/${myBot.businessOwnerApprovalDocumentLink}`}
                                  >{`${endpoints.fetchBlobUrl}/${myBot.businessOwnerApprovalDocumentLink}`}</a>
                                
                              </h5>
                            </div>
                          </div> : null }




                       

                          <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>KFA IUC</p>
                              <h5>
                                {
                                   myBot.kfaIuc
                                  ? "Yes" : myBot.kfaIuc === false ? "No"
                                  : "--"}
                              </h5>
                            </div>
                            <div className={styles.right}>
                              <p>CONTROL IMPACTED</p>
                              <h5>
                                {myBot?.controlActivityType  ? myBot.controlActivityType : "None"}
                              </h5>
                            </div>
                          </div>

                           <div className={`${styles.cardRow}`}>
                            <div className={styles.left}>
                              <p>Control Number</p>
                              <h5>
                                {myBot?.controlNumber ? myBot.controlNumber : "-"}
                              </h5>
                            </div>
                          </div>

                        </div>

                        {myBot.firstLevelControlTable === undefined ||
                        myBot.firstLevelControlTable == "" ||
                        myBot.firstLevelControlTable == null ? null : (
                          <div className={styles.txtCard}>
                            <h1 className={styles.cardHeading}>
                              Approval Control Tables
                            </h1>

                            {myBot.firstLevelControlTable != null &&
                            myBot.firstLevelControlTable != undefined &&
                            myBot.firstLevelControlTable != "null"
                              ? JSON.parse(
                                  _.get(myBot, "firstLevelControlTable", "[]")
                                ).map((item, index) => {
                                  return (
                                    <div className={styles.controlTable}>
                                      {Object.keys(item).map(
                                        (objectItem, index) => (
                                          <>
                                            <div
                                              className={`${styles.cardRow} ${styles.fullwidth} ${styles.controlTable}`}
                                              key={index}
                                            >
                                              <div className={styles.center}>
                                               {index == 3 ?  <p>{ objectItem ? objectItem.slice(0,10): " "+ " " + objectItem ? objectItem.slice(10): " "}</p> :
                                                <p>{objectItem ? objectItem.slice(0,7) : " "+ " " + objectItem ? objectItem.slice(7) : "  "}</p> }
                                                <h5>{item[objectItem]}</h5>
                                              </div>
                                            </div>
                                          </>
                                        )
                                      )}
                                    </div>
                                  );
                                })
                              : null}
                          </div>
                        )}
                      </>
                    ) : null}
                  </div>
                  <div className={styles.mediaContent}>
                    {myBot.botDemoVideo == null ||
                    myBot.botDemoVideo == "" ||
                    myBot.botDemoVideo == "undefined" ||
                    myBot.botDemoVideo == undefined ||
                    myBot.botDemoVideo === undefined ||
                    myBot.botDemoVideo == "can be empty" ? null : (
                      <div className={styles.videWrapper}>
                        <ReactPlayer
                          width="100%"
                          height="100%"
                          controls
                          url={`${endpoints.fetchBlobUrl}/botDocuments/${myBot.documentFolderName}/${myBot.botDemoVideo}?${sasToken}`}
                        />
                      </div>
                    )}

                    {currentDocumentExtension !== "" &&
                    currentDocumentExtension !== undefined &&
                    currentDocumentExtension !== null &&
                    myBot[selectedDropdown] !== null &&
                    myBot[selectedDropdown] !== undefined &&
                    myBot[selectedDropdown] !== "" &&
                    myBot[selectedDropdown] !== "NA" &&
                    myBot[selectedDropdown] !== "NULL" ? (
                      <div className={styles.pdfWrapper}>
                        <div className={styles.pdfHead}>
                          <p className={styles.pdfText}>Documents</p>

                          <div
                            className={styles.threeDots}
                            onClick={openDocumentSelector}
                          >
                            <Icons
                              name="threeDots"
                              className={styles.plusIcon}
                            />
                          </div>
                        </div>
                        {documentDropdown ? (
                          <div className={styles.dropdownWrapper}>
                            <div className={styles.dropdown}>
                              <Dropdown
                                dropdownParent="documentType"
                                values={documentTypes}
                                getDropdownValue={gotDropDownValue}
                                haveRelated={null}
                                params="botDetailDocument"
                                closeAllDropdowns={() =>
                                  setDocumentDropdown(false)
                                }
                              />
                            </div>
                          </div>
                        ) : null}

                        <div className={styles.pdfsubHead}>
                          <Icons
                            name={currentDocumentExtension}
                            className={styles.icon}
                          />
                          <p className={styles.pdfText}>
                            {
                              documentAr.filter(
                                (item) => item.value == selectedDropdown
                              )[0].title
                            }
                          </p>
                          <div
                            onClick={() => {
                              window.open(
                                `${endpoints.fetchBlobUrl}/botDocuments/${myBot.documentFolderName}/${myBot[selectedDropdown]}?${sasToken}`
                              );
                            }}
                            className={styles.downloadIcon}
                          >
                            <Icons name="downloadBlue"></Icons>
                          </div>
                        </div>
                        {myBot[selectedDropdown] !== null &&
                        myBot[selectedDropdown] !== "" &&
                        myBot[selectedDropdown] != "can be empty" ? (
                          <div className={styles.pdfmainHead}>
                            <iframe
                            
                              ref={frameRef}
                              src={
                                currentDocumentExtension == "pdf" ||
                                currentDocumentExtension == "jpg" ||
                                currentDocumentExtension == "mp4"
                                  ? `${endpoints.fetchBlobUrl}/botDocuments/${myBot.documentFolderName}/${myBot[selectedDropdown]}?${sasToken}`
                                  : currentDocumentExtension == "xlsx" ||
                                    currentDocumentExtension == "xls" ||
                                    currentDocumentExtension == "doc" ||
                                    currentDocumentExtension == "docx"
                                  ? `https://docs.google.com/viewerng/viewer?embedded=true&url=${endpoints.fetchBlobUrl}/botDocuments/${myBot.documentFolderName}/${myBot[selectedDropdown]}?${sasToken}`
                                  : currentDocumentExtension == "ppt" ||
                                    currentDocumentExtension == "pptx" ||
                                    currentDocumentExtension == "msg"
                                  ? `https://view.officeapps.live.com/op/embed.aspx?src=${endpoints.fetchBlobUrl}/botDocuments/${myBot.documentFolderName}/${myBot[selectedDropdown]}?${sasToken}`
                                  : `${endpoints.fetchBlobUrl}/botDocuments/${myBot.documentFolderName}/${myBot[selectedDropdown]}?${sasToken}`
                              }
                              type={`application/${currentDocumentExtension}`}
                              width="100%"
                              height="532px"
                              //  border="none"
                            ></iframe>
                          
                          </div>
                        ) : (
                          <span
                            style={{
                              position: "absolute",
                              marginLeft: "200px",
                              marginTop: "200px",
                            }}
                          >
                            Does not exist
                          </span>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>

                {editUser.includes(authData.userType) &&
                props.type != "previewPage" ? (
                  <span
                    className={`${styles.getBot} ${styles.editBotBtn}`}
                    onClick={editBot}
                  >
                    Edit This Bot
                  </span>
                ) : null}
              </div>
            </div>
          ) : null}

          {props.type == "previewPage" ? null : (
            <div className={`${styles.BotdetailsCard} container`}>
              {similarBots.length > 0 ? (
                <p className={styles.commonText}>More similar bots</p>
              ) : null}

              <div className={styles.parentCard}>
                {similarBots.map((bot, index) =>
                  index < 3 ? (
                    <div className={styles.similarCards}>
                      <Botcard key={index} data={bot} />
                    </div>
                  ) : null
                )}
              </div>
            </div>
          )}
        </>
      )}
       {reviewModal ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white w-[900px] relative h-[400px] flex !rounded-lg !rounded-br-[80px]">
            <button
              className="bg-[#D4E3FD] absolute right-2 top-2 text-[#033166] rounded-full w-6 h-6 flex items-center justify-center"
              onClick={() => setReviewModal(false)}
            >
              X
            </button>
            <Image
              className="w-[400px] object-cover rounded-lg rounded-br-[80px]"
              width={400}
              src={review_modal_img}
              alt="Review Modal"
            />
            <div className="py-6 px-10  flex flex-col gap-12">
              <h1 className="text-[#005EEF] text-[32px]">Bot Review</h1>
              <div>
                <p className="text-[#005EEF] text-[16px] !mb-1">
                  Choose a reviewer
                </p>
                <input
                  type="text"
                  className="!border-b-2 bg-inherit border-[#D4E3FD]  w-[400px] h-[40px] p-2"
                  disabled
                  value={"Ritika.Kaushik@unilever.com"}
                />
              </div>

              <button
                className="bg-[#005EEF] p-2 w-[160px] text-white rounded-br-[20px] rounded-tr-[20px] "
                onClick={() => {
                  props.createTheBot();
                  setReviewModal(false);
                }}
              >
                Submit Bot Review
              </button>
            </div>
          </div>
        </div>
      ) : null}
      {props.type == "previewPage" ? (
        <div className="container my-3">
          <div className={styles.combinedBtn}>
            <span className={styles.rowBtn} onClick={props.backToEdit}>
              <Icons name="arrowback" className={styles.plusIcon} />
              Back to edit mode
            </span>

            <span className={styles.exportListBtn} onClick={() => setReviewModal(true)}>
              Save and Proceed
            </span>
          </div>
        </div>
      ) : null}
      {botModal ? (
        <GetBotModal
          setbotModal={setbotModal}
          botName={myBot.processName}
          botID={myBot.botID}
          setSuccessModal={setSuccessModal}
          setBotModal={setbotModal}
          leadPlatform={myBot.leadPlatform}
          technology={myBot.technology}
          globalData={props.globalData}
          data={props.data.data.field_create_bot_component[0].component.content}
          setLoading = {setLoading }
        />
      ) : null}
    </>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
    tokenStatus: state.session.token,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);


